import { useQuery } from '@tanstack/react-query';
import type { JobChangeProcessDetailResponse } from '../types/JobChangeProcess';

export default function useFetchJobChangeProcess(id: number | null) {
  return useQuery({
    queryKey: ['jobChangeProcesses', id, 1, ''],
    enabled: id !== null,
    queryFn: async () => {
      const response = await fetch(`/agent/api/job_change_processes/${id}.json`);
      // エラーボディをそのまま返すと data が truthy になり、参照側が undefined を読んで画面ごと落ちる
      if (!response.ok) throw new Error('選考プロセスの取得に失敗しました');
      const data: JobChangeProcessDetailResponse = await response.json();

      return data;
    },
  });
}
